module.exports = __webpack_public_path__ + "static/media/killers.297f7f18.jpg";